export default __webpack_public_path__ + "static/media/cjupdate-05.a07b2581.png";